





























































































import IconButton from "@/components/IconButton.vue";
import Vue from "vue";
import flowStore, { InvoiceFlowStore } from "@/modules/invoiceFlow/services/InvoiceFlowStore";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import MoneyInput from "@/components/MoneyInput.vue";
import CheckBox from "@/components/CheckBox.vue";
import * as api from "@/modules/invoiceItems/services/api";
import WorkSheetItemGpart from "@/modules/invoiceItemDimension/models/WorkSheetItemGpart";
import WorkSheetItemRelation from "@/modules/invoiceItemDimension/models/WorkSheetItemRelations";
import { t } from "@/plugins/i18n";

interface Data {
  flowStore: InvoiceFlowStore;
  workSheetItemRelaions: any[];
  newWorkSheetItemRelaions: WorkSheetItemGpart[];
  searchText: string;

  selectedItems: WorkSheetItemGpart[];

  autocompleteItems: any[];
  gpartsFilter: boolean;
  //selectedAutocompleteItem: string;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: { IconButton, MoneyDisplay, CheckBox },
  props: {
    invItemId: Number,
    invItemGpartId: Number,
    invItemNetto: Number,
  },

  data() {
    return {
      flowStore,
      workSheetItemRelaions: [],
      newWorkSheetItemRelaions: [],
      searchText: "",

      selectedItems: [],
      autocompleteItems: [
        {
          id: 0,
          name: t("InvoiceItems_SzamlaTetellelMegegyezoGparts"),
        },
        {
          id: 1,
          name: t("InvoiceItems_BarmilyenGparts"),
        },
      ],
      selectedAutocompleteItem: {
        id: 0,
        name: t("InvoiceItems_SzamlaTetellelMegegyezoGparts"),
      },
      gpartsFilter: true,
    };
  },

  async beforeMount() {
    this.workSheetItemRelaions = await api.getCurrentWorkSheetItemRelations(Number(this.$props.invItemId));
  },

  methods: {
    autocompleteItemChanged(e: any) {
      if (e.id == 0) {
        this.gpartsFilter = true;
      } else this.gpartsFilter = false;
    },

    async search(e: KeyboardEvent) {
      if (e.key != "Enter") {
        return;
      }
      this.newWorkSheetItemRelaions = (
        await api.searchWorkSheetItemRelations(
          this.searchText,
          this.flowStore.invoice.partner,
          Number(this.$props.invItemGpartId),
          this.gpartsFilter,
          this.flowStore.invoice.rectify
        )
      ).map((x: WorkSheetItemGpart) => ({ ...x, isSelected: false }));
    },

    clear() {
      this.newWorkSheetItemRelaions = [];
      this.searchText = "";
    },

    selectItem(item: WorkSheetItemGpart) {
      if (!item.isSelected) {
        item.isSelected = true;
        this.selectedItems.push(item);
      } else {
        item.isSelected = false;
        this.selectedItems = this.selectedItems.filter((x) => x.id == item.id);
      }
    },

    async deleteItem(item: any) {
      this.workSheetItemRelaions = this.workSheetItemRelaions.filter((x) => x.relationId != item.relationId);
      await api.deleteWorkSheetItemRelation(item.relationId);
    },

    async addItems() {
      if (this.selectedItems.length == 0) {
        return;
      }

      const items: any = [];
      this.selectedItems.forEach((e) => {
        items.push({
          id: 1,
          invNo: Number(this.$route.params.invoiceId),
          wsCont: e.id,
          itemId: Number(this.$props.invItemId),
          total: Number(e.netto),
          operelSubcontractorOrderItem: 1,
          facSheetCoop: 1,
          note: "",
        });
      });

      console.log(items);

      const success = await api.addWorkSheetItemRelation(items);
      this.newWorkSheetItemRelaions = [];
      this.workSheetItemRelaions = await api.getCurrentWorkSheetItemRelations(Number(this.$props.invItemId));
      this.selectedItems = [];
      
      if (success) {
        this.flowStore.invoice.type = 4;
      }
    },
  },

  computed: {
    columns: () => [
      { field: "workSheetHeadId", title: t("InvoiceItems_MunkalapFej") },
      { field: "regNum", title: t("Rendszam") },
      { field: "bodyNo", title: t("Alvazszam") },
      { field: "partnerName", title: t("Alvallalkozo") },
      { field: "orderDate", title: t("InvoiceItems_LezarasDatuma"), type: "date", format: "{0: yyyy. MM. dd.}" },
      // { field: "gpartName", title: "Gparts neve" },
      { field: "statusName", title: t("Statusz") },
      { field: "netto", title: t("NettoOsszeg"), cell: "nettoTemplate", headerClassName: "right_text" },
      { cell: "commandTemplate", width: "60px" },
      { width: 0 },
    ],

    newColumns: () => [
      { field: "workSheetHeadId", title: t("InvoiceItems_MunkalapFej") },
      { field: "regNum", title: t("Rendszam") },
      { field: "bodyNo", title: t("Alvazszam") },
      { field: "defrayerName", title: t("Vevo") },
      { field: "partnerName", title: t("Alvallalkozo") },
      { field: "gpartName", title: t("InvoiceItems_GpartsNeve") },
      { field: "orderDate", title: t("InvoiceItems_LezarasDatuma"), type: "date", format: "{0: yyyy. MM. dd.}" },
      { field: "netto", title: t("NettoOsszeg"), cell: "nettoTemplate", headerClassName: "right_text" },
      { cell: "commandTemplate", width: "60px" },
      { width: 0 },
    ],
  },
});
